import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=47586fe6&scoped=true"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47586fe6",
  null
  
)

export default component.exports